import * as React from "react";
import {
  Box,
  InputLabel,
  Typography,
  Checkbox,
  FormGroup,
  FormControlLabel,
  Grid,
  TextareaAutosize,
  CircularProgress,
  List,
  ListItem,
  FormControl,
  FormHelperText,
} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { Table, TableBody, TableRow, TableCell } from "@mui/material";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";

import { CustomEllipticalButton, CustomInput } from "Components/Form";
import { Colors } from "Utils/colors";
import { Strings } from "Utils/strings";
import { useContext, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { useFormik } from "formik";
import { isValidString } from "Utils/validators";
import { formatAsUsPhoneNo } from "Utils/transform";
import { CustomNumberInput } from "Components/Form/CustomNumberInput";
import { SnackBarContext } from "Context/SnackContext";
import { InFlow } from "Features/services/inFlow.api";
import { useAppDispatch, useAppSelector } from "Hooks/reduxHook";
import { Customer, customers } from "Features/services/customer.api";
import debounce from "lodash.debounce";
import { useCallback, useEffect } from "react";
import { getAccessToken } from "Features/slice/customer/customer.Slice";
import DatePicker from "react-datepicker";
import { Invoices } from "Features/services/invoice.api";
import { useLocation, useNavigate } from "react-router-dom";
import { useCustomer } from "Context/CustomerContext";
import axios from "axios";
import { Shipstation } from "Features/services/shipstation.api";
import { invoiceSchema } from "../../Schema";
import { RootState } from "Features/store";
import { Country, State, City } from "country-state-city";

export const orderStatuses: string[] = [
  "In Process",
  "Completed",
  "Order Received",
  "Order Processing",
  "Order Picked",
  "Packing",
  "Awaiting Shipment",
  "Shipped",
  "In Transit",
  "Out For Delivery",
  "Delivered",
  "Failed Delivery",
  "Returned To Sender",
  "Held At Customs",
  "Customs Cleared",
  "Awaiting Pickup",
  "Delivery Delayed",
  "Returned",
  "Cancelled",
  "Lost In Transit",
  "Damaged In Transit",
];

// const stateOptions: string[] = [
//   "AL",
//   "AK",
//   "AZ",
//   "AR",
//   "CA",
//   "CO",
//   "CT",
//   "DE",
//   "DC",
//   "FL",
//   "GA",
//   "HI",
//   "ID",
//   "IL",
//   "IN",
//   "IA",
//   "KS",
//   "KY",
//   "LA",
//   "ME",
//   "MD",
//   "MA",
//   "MI",
//   "MN",
//   "MS",
//   "MO",
//   "MT",
//   "NE",
//   "NV",
//   "NJ",
//   "NM",
//   "NY",
//   "NC",
//   "ND",
//   "OH",
//   "OK",
//   "OR",
//   "PA",
//   "RI",
//   "SC",
//   "SD",
//   "TN",
//   "TX",
//   "UT",
//   "VT",
//   "VA",
//   "WA",
//   "WV",
//   "WI",
//   "WY",
// ];

const formatStatus = (status: string) => {
  return status.toLowerCase().replace(/ /g, "_");
};

interface IShippingCostOption {
  serviceCode: string;
  shipmentCost: number;
  otherCost: number;
  serviceName: string;
}

type Product = {
  item: string;
  qty: number;
  price: number;
  id: string;
  fieldType: string;
  weight: string;
};

const InvoiceInformation = () => {
  const { handleSnackbar } = useContext(SnackBarContext);
  const navigate = useNavigate();
  const location = useLocation();
  const { customerData, setCustomerData } = useCustomer();
  const [draftData, setDraftData] = useState(location.state?.draftData || {});

  console.log("draftData--", draftData);

  const generateAndSetInvoiceNo = () => {
    const prefix = "FL00";
    const randomDigits = Math.floor(1000 + Math.random() * 9000);
    const newInvoiceNo = `${prefix}${randomDigits}`;
    setInvoiceNo(newInvoiceNo);
    return newInvoiceNo;
  };

  const [invoiceNo, setInvoiceNo] = useState("");

  const [state, setState] = useState(
    draftData?.bill_addr?.CountrySubDivisionCode || ""
  );
  const [city, setCity] = useState(draftData?.bill_addr?.City || "");

  const stateOptions = State.getStatesOfCountry("US");

  const cityOptions = state ? City.getCitiesOfState("US", state) : [];

  const [shippingState, setShippingState] = useState(
    draftData?.ship_addr?.CountrySubDivisionCode || ""
  );
  const [shippingCity, setShippingCity] = useState(
    draftData?.ship_addr?.City || ""
  );

  const shippingStateOptions = State.getStatesOfCountry("US");

  const shippingCityOptions = shippingState
    ? City.getCitiesOfState("US", shippingState)
    : [];

  const [shippingOptions, setShippingOptions] = useState<any>([]);
  const [carrierloading, setCarrierLoading] = useState<boolean>(false);

  const [shippingEnvelope, setShippingEnvelope] = useState<any>([]);
  const [envelopeLoading, setEnvelopeLoading] = useState<boolean>(false);

  const [shippingCostOption, setShippingCostOption] = useState<
    IShippingCostOption[]
  >([]);
  const [costLoading, setCostLoading] = useState<boolean>(false);

  const [productWeight, setProductWeight] = useState<any>("");
  const [shippingCost, setShippingCost] = useState<number>(0);

  const [customerSelected, setCustomerSelected] = useState<boolean>(false);
  const [showAddCustomerBtn, setShowAddCustomerBtn] = useState(false);

  const [productSelected, setProductSelected] = useState<boolean>(false);

  const dispatch = useAppDispatch();

  const { access_token } = useAppSelector( (state: RootState) => state.customer);


  console.log("accessToken---", access_token);

  // const handleAccessToken = async () => {
  //   try {
  //     const response = await Customer.instance.getAccessToken();
  //     console.log(response.data.data);
  //     setAccessToken(response.data.data)
  //   } catch (error: any) {
  //     handleSnackbar(
  //       true,
  //       error?.response?.data?.message || "Something went wrong",
  //       error
  //     );
  //   }
  // };

  useEffect(()=> {
    getAccessToken()
  }, [access_token])

  const debounceTimeout = React.useRef<NodeJS.Timeout | null>(null);

  const loadFormData: any = () => {
    const savedData = sessionStorage.getItem("formData");
    const parsedData = savedData ? JSON.parse(savedData) : {};

    if (parsedData.dueDate) {
      parsedData.dueDate = new Date(parsedData.dueDate);
    }

    if (parsedData.date) {
      parsedData.date = new Date(parsedData.date);
    }

    return parsedData;
  };

  const initialValues = {
    display_name: draftData?.user_info?.display_name || "",
    email: draftData?.user_info?.email || "",
    qb_customer_id: draftData?.user_info?.quickbook_customer_id || "",
    phoneNo: draftData?.user_info?.phoneNo || "",
    address: draftData?.bill_addr?.Line1 || "",
    state: draftData?.bill_addr?.CountrySubDivisionCode || state,
    city: draftData?.bill_addr?.City || city,
    zip: draftData?.bill_addr?.PostalCode || "",
    poNumber: draftData?.invoice_info?.poNumber || "",
    salesRep: draftData?.invoice_info?.salesRep || "",
    shippingOptions: draftData?.shippingOptions || "",
    shippingEnvelope: draftData?.shippingEnvelope || "",
    shippingCostOption: draftData?.shippingCostOption || "",

    salesTax: draftData?.cart_info?.salesTax || "6",
    discounts: draftData?.cart_info?.discounts || "",
    option: draftData?.cart_info?.option || "Amount",

    notes: draftData?.invoice_info?.notes || "",
    invoiceNo: draftData?.invoice_info?.invoiceNo || invoiceNo,

    date: draftData?.invoice_info?.date
      ? new Date(draftData?.invoice_info?.date)
      : new Date(),

    dueDate: draftData?.invoice_info?.dueDate
      ? new Date(draftData?.invoice_info?.dueDate)
      : new Date(),

    invoiceStatus: draftData?.invoice_info?.invoiceStatus || "In Process",
    customerType: draftData?.invoice_info?.customerType || "Retail",

    id: draftData?.id || "",
    isDraft: draftData?.status || "",

    billingSameAsShipping:
      draftData?.ship_addr?.billingSameAsShipping === false
        ? draftData?.ship_addr?.billingSameAsShipping
        : true,

    shippingName: draftData.ship_addr?.shippingName || "",
    shippingAddress: draftData?.ship_addr?.Line1 || "",
    shippingState:
      draftData?.ship_addr?.CountrySubDivisionCode || shippingState,
    shippingCity: draftData?.ship_addr?.City || shippingCity,
    shippingZip: draftData?.ship_addr?.PostalCode || "",
  };

  let initialStateProduct: Product = {
    item: "",
    qty: 0,
    price: 0,
    id: "",
    fieldType: "blank",
    weight: "",
  };

  const loadProductData = () => {
    const savedProducts = sessionStorage.getItem("products");
    return savedProducts
      ? JSON.parse(savedProducts)
      : draftData?.products?.length
      ? draftData.products
      : [initialStateProduct];
  };

  const [loading, setLoading] = useState<boolean>(false);
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [searchResults, setSearchResults] = useState<any[]>([]);
  const [showDropDown, setShowDropDown] = useState<boolean>(false);
  const [activeIndex, setActiveIndex] = useState(null);

  // const [product, setProduct] = useState<(typeof initialStateProduct)[]>([
  //   initialStateProduct,
  // ]);

  const [product, setProduct] = useState<Product[]>(loadProductData());

  const [customerLoading, setCustomerLoading] = useState<boolean>(false);
  const [customerSearchResult, setCustomerSearchResult] = useState<any[]>([]);
  const [customerQuery, setCustomerQuery] = useState<string>("");
  const [customerDropDown, setCustomerDropDown] = useState<boolean>(false);

  const [showCalendar, setShowCalendar] = useState(false);
  const [showDateCalendar, setShowDateCalendar] = useState(false);


  useEffect(() => {
    const newInvoiceNo = generateAndSetInvoiceNo();
    billingForm.setFieldValue("invoiceNo", newInvoiceNo);
  }, []);

  const billingForm = useFormik({
    initialValues,
    validationSchema: invoiceSchema,
    onSubmit: async (values, { setSubmitting, setErrors }) => {
      const invoiceInfo = {
        invoiceNo: values.invoiceNo,
        date: values.date,
        dueDate: values.dueDate,
        invoiceStatus: formatStatus(values.invoiceStatus),
        notes: values.notes,
        poNumber: values.poNumber,
        salesRep: values.salesRep,
      };
      const userInfo = {
        customerType: values.customerType,
        display_name: values.display_name,
        email: values.email,
        quickbook_customer_id: values.qb_customer_id,
        phoneNo: values.phoneNo,
      };

      const BillAddr = {
        Line1: values.address,
        City: values.city,
        CountrySubDivisionCode: values.state,
        PostalCode: values.zip,
      };

      const ShipAddr = values.billingSameAsShipping
        ? BillAddr
        : {
            Line1: values.shippingAddress,
            City: values.shippingCity,
            CountrySubDivisionCode: values.shippingState,
            PostalCode: values.shippingZip,
          };

      const hasDiscount = values.discounts > 0;
      const discountType = hasDiscount
        ? values.option === "Amount"
          ? "Fixed"
          : values.option === "Percent"
          ? "Percentage"
          : null
        : null;

      const hasFloridaTax = values.salesTax === "6" ? true : false;

      const cartInfo = {
        hasDiscount,
        discountType,
        discountQuantity: hasDiscount ? values.discounts : 0,
        hasFloridaTax,
      };

      let payload = {
        access_token,
        userInfo,
        invoiceInfo,
        products: product,
        cartInfo,
        BillAddr,
        ShipAddr,
        id: values.id,
        isDraft: values.isDraft,
        shippingName: values.shippingName,
        billingSameAsShipping: values.billingSameAsShipping,
      };

      // Submit the payload
      try {
        debugger;
        const response = await Invoices.instance.createInvoice(payload);
        handleSnackbar(true, `Invoice created successfully`, "success");
        resetFormDetails();
        setDraftData({});
      } catch (error: any) {
        handleSnackbar(true, `${error.message}`, "error");
      } finally {
        setSubmitting(false);
      }
    },
  });

  // Function for saving as draft
  const handleSavedDraft = async () => {
    debugger;
    const values = billingForm.values;

    const invoiceInfo = {
      invoiceNo: values.invoiceNo,
      date: values.date,
      dueDate: values.dueDate,
      invoiceStatus: values.invoiceStatus,
      notes: values.notes,
      poNumber: values.poNumber,
      salesRep: values.salesRep,
    };

    const userInfo = {
      display_name: values.display_name,
      email: values.email,
      quickbook_customer_id: values.qb_customer_id,
      phoneNo: values.phoneNo,
    };

    const BillAddr = {
      Line1: values.address,
      City: values.city,
      CountrySubDivisionCode: values.state,
      PostalCode: values.zip,
    };

    const ShipAddr = values.billingSameAsShipping
      ? BillAddr
      : {
          Line1: values.shippingAddress,
          City: values.shippingCity,
          CountrySubDivisionCode: values.shippingState,
          PostalCode: values.shippingZip,
        };

    const hasDiscount = values.discounts > 0;
    const discountType = hasDiscount
      ? values.option === "Amount"
        ? "Fixed"
        : values.option === "Percent"
        ? "Percentage"
        : null
      : null;

    const hasFloridaTax = values.salesTax === "6" ? true : false;

    const cartInfo = {
      discounts: values.discounts,
      hasFloridaTax,
      // shippingOptions: values.shippingOptions,
      // salesTax: values.salesTax,
      // discounts: values.discounts,
      // option: values.option,
      // subTotal: getTotal(),
      // netTotal: getGrandTotal(),
    };

    // Constructing the payload

    let payload = {
      access_token,
      userInfo,
      invoiceInfo,
      products: product,
      BillAddr,
      ShipAddr,
      cartInfo,
      id: values.id,
      isDraft: values.isDraft,
      billingSameAsShipping: values.billingSameAsShipping,
      shippingName: values.shippingName,
    };

    try {
      debugger;
      const response = await Invoices.instance.saveDraftInvoice(payload);
      handleSnackbar(true, `Invoice saved in draft successfully`, "success");
      resetFormDetails();
    } catch (error: any) {
      handleSnackbar(true, `${error.message}`, "error");
    }
  };

  const addProductRow = () => {
    const newProduct = {
      ...initialStateProduct,
      id: uuidv4(),
      fieldType: "blank",
    };
    setProduct((prevProduct) => [...prevProduct, newProduct]);
  };

  const removeRow = (id: any) => {
    setProduct(product.filter((row) => row.id !== id));
  };

  const getSubtotal = React.useCallback(() => {
    return product.reduce(
      (acc, currentValue) =>
        acc + (currentValue.price || 0) * (currentValue.qty || 0),
      0
    );
  }, [product]);

  const getTotal = React.useCallback(() => {
    const subtotal = getSubtotal();

    const discount = parseFloat(billingForm.values.discounts) || 0;
    const option = billingForm.values.option;

    let totalPrice = subtotal;

    if (option === "Amount") {
      totalPrice = subtotal - discount;
    } else if (option === "Percent") {
      const percentDiscount = discount / 100;
      totalPrice = subtotal - subtotal * percentDiscount;
    }

    totalPrice = totalPrice > 0 ? totalPrice : 0;

    return parseFloat(totalPrice.toFixed(2));
  }, [
    product,
    billingForm.values.discounts,
    billingForm.values.option,
    getSubtotal,
  ]);

  const getGrandTotal = React.useCallback(() => {
    const totalPrice = getTotal();

    // Convert sales tax percentage to amount
    const salesTaxPercentage = parseFloat(billingForm.values.salesTax) || 0;
    const salesTaxAmount = (salesTaxPercentage / 100) * totalPrice;

    const grandTotal = totalPrice + salesTaxAmount + (shippingCost || 0);

    return parseFloat(grandTotal.toFixed(2));
  }, [getTotal, billingForm.values.salesTax, shippingCost]);

  const resetFormDetails = () => {
    setProduct([initialStateProduct]);

    const newInvoiceNo = generateAndSetInvoiceNo();

    billingForm.resetForm({
      values: {
        display_name: "",
        email: "",
        qb_customer_id: "",
        phoneNo: "",
        address: "",
        city: "",
        state: "",
        zip: "",
        poNumber: "",
        salesRep: "",
        billingSameAsShipping: true,
        shippingOptions: "",
        shippingEnvelope: "",
        shippingCostOption: "",
        salesTax: "6",
        discounts: "",
        option: "Amount",
        notes: "",
        invoiceNo: newInvoiceNo,
        dueDate: new Date(),
        date: new Date(),
        customerType: "Retail",
        invoiceStatus: "In Process",
        id: "",
        isDraft: "",
        shippingName: "",
        shippingAddress: "",
        shippingCity: "",
        shippingState: "",
        shippingZip: "",
      },
    });

    setState("");
    setCity("");
    setShippingState("");
    setShippingCity("");

    setDraftData({});
  };

  const fetchSearchResults = async (query: string) => {
    try {
      setLoading(true);
      const response = await InFlow.instance.searchProducts(20, query);
      const data = response.data?.productsList;
      setSearchResults(data || []);
      setShowDropDown(true);
    } catch (error: any) {
      handleSnackbar(true, "Something went wrong. Please try again.", "error");
      console.error("Something went wrong", error);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (value: any, index: any, field: string) => {
    setActiveIndex(index);
    setProduct((prevProducts) =>
      prevProducts.map((productItem, i) =>
        i === index ? { ...productItem, [field]: value } : productItem
      )
    );

    if (field === "item") {
      setSearchQuery(value);

      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }

      debounceTimeout.current = setTimeout(() => {
        if (!billingForm.values.customerType) {
          handleSnackbar(
            true,
            "Please select a Customer Type before searching for products.",
            "error"
          );
          return;
        }

        if (value.trim()) {
          fetchSearchResults(value);
        } else {
          setProduct((prevProducts: any) =>
            prevProducts.map((productItem: any, i: any) =>
              i === index
                ? { ...productItem, item: "", price: 0, qty: "" }
                : productItem
            )
          );
        }
      }, 400);
    }
  };

  const handleResultClick = (selectedProduct: any) => {
    debugger;
    if (activeIndex !== null) {
      let price;
      switch (billingForm.values.customerType) {
        case "Wholesale":
          price = selectedProduct?.wholesalePrice;
          break;
        case "In_House":
          price = selectedProduct?.company_cost;
          break;
        case "Retail":
        default:
          price = selectedProduct?.unitPrice;
          break;
      }

      const new_item = {
        item: selectedProduct.name,
        price: price,
        id: selectedProduct.productId || selectedProduct.productListingObjectId,
        qty: 1,
        weight: selectedProduct?.weight,
      };

      // Update the current active product if it doesn't already exist
      setProduct((prevProducts) => {
        const updatedProducts = [...prevProducts];
        const currentProduct = updatedProducts[activeIndex];

        // Check if the selected product is already in the list
        const isDuplicate = updatedProducts.some(
          (product) =>
            product.id === new_item.id && product.id !== currentProduct.id
        );

        if (!isDuplicate) {
          updatedProducts[activeIndex] = { ...currentProduct, ...new_item };
          setProductSelected(true);
          return updatedProducts;
        } else {
          handleSnackbar(true, "Product already exists", "error");
          return prevProducts; // Return the previous products if duplicate exists
        }
      });

      // Clear search results and hide dropdown
      setSearchResults([]);
      setShowDropDown(false);
      setSearchQuery("");
    }
  };

  const handleSearchCustomer = async (value: string) => {
    if (!access_token) {
      handleSnackbar(true, "Your token has been expired, please refresh it", "error");
      return;
    }
  
    if (!value) {
      setCustomerSearchResult([]);
      setCustomerDropDown(false);
      setShowAddCustomerBtn(false);
      return;
    }
  
    const payload = {
      access_token: access_token,
      search_query: value,
      offset: 0,
    };
  
    try {
      setCustomerLoading(true);
      const response = await Customer.instance.searchCustomer(payload);
      const data = response.data.data;
      setCustomerSearchResult(data);
      setCustomerDropDown(true);
  
      const matchFound = data.some((customer: any) =>
        customer.display_name.toLowerCase().includes(value.toLowerCase())
      );
      setShowAddCustomerBtn(!matchFound);
    } catch (error: any) {
      if (error.response?.status === 500) {
        handleSnackbar(
          true,
          "Your token has been expired, please refresh it",
          "error"
        );
        dispatch(getAccessToken())
      } else {
        handleSnackbar(
          true,
          "Something went wrong. Please try again.",
          "error"
        );
      }
    } finally {
      setCustomerLoading(false);
    }
  };
  

  const debouncedSearchCustomer = useCallback(
    debounce(handleSearchCustomer, 400),
    []
  );

  const handleCustomerClick = (customer: any) => {
    debugger;
    setCustomerData(customer);
    setCustomerSelected(true);

    billingForm.setValues((prevValues: any) => ({
      ...prevValues,
      display_name: customer.display_name || prevValues.display_name,
      email: customer.email || prevValues.email,
      qb_customer_id: customer.qb_customer_id || prevValues.qb_customer_id,
      phoneNo: customer.phoneNo || prevValues.phoneNo,
      address: customer.address || prevValues.address,
      state: customer.countrySubDivisionCode || prevValues.state,
      city: customer.city || prevValues.city,
      zip: customer.zip || prevValues.zip,
    }));
    setCustomerDropDown(false);
  };

  const fetchListCarriers = async () => {
    setCarrierLoading(true);
    try {
      const response = await Shipstation.instance.listCarriers();
      const filteredOptions = response.data.filter(
        (option: any) =>
          option.name === "Stamps.com" || option.name === "UPS by ShipStation"
      );

      setShippingOptions(filteredOptions);
    } catch (error) {
      handleSnackbar(true, "Something went wrong. Try again", "error");
    } finally {
      setCarrierLoading(false);
    }
  };

  const { firstname, lastname } = useAppSelector(
    (state: RootState) => state.user.userInfo
  );

  const uName = `${firstname} ${lastname || ""}`;

  useEffect(() => {
    billingForm.setFieldValue("salesRep", uName);
  }, [uName]);

  useEffect(() => {
    fetchListCarriers();
  }, []);

  useEffect(() => {
    if (billingForm.values.shippingOptions) {
      const fetchPackagesList = async () => {
        setEnvelopeLoading(true);
        try {
          const response = await Shipstation.instance.packagesList(
            billingForm.values.shippingOptions
          );
          setShippingEnvelope(response.data);
        } catch (error) {
          console.error("Error fetching envelopes:", error);
        } finally {
          setEnvelopeLoading(false);
        }
      };

      fetchPackagesList();
      billingForm.setFieldValue("shippingEnvelope", "");
      billingForm.setFieldValue("shippingCostOption", "");
      setShippingCostOption([]);
    } else {
      setShippingEnvelope([]);
      billingForm.setFieldValue("shippingEnvelope", "");
      setShippingCostOption([]);
      billingForm.setFieldValue("shippingCostOption", "");
    }
  }, [billingForm.values.shippingOptions]);

  useEffect(() => {
    const totalWeight = product.reduce(
      (acc: any, curr: any) => acc + curr.qty * curr.weight,
      0
    );
    setProductWeight(totalWeight);
  }, [product]);

  useEffect(() => {
    if (billingForm.values.shippingEnvelope) {
      const fetchShipRates = async () => {
        const payload = {
          carrierCode: billingForm.values.shippingOptions,
          serviceCode: null,
          packageCode: billingForm.values.shippingEnvelope,
          toState: billingForm.values.shippingState || billingForm.values.state,
          toCountry: "US",
          toPostalCode:
            billingForm.values.shippingZip || billingForm.values.zip,
          toCity: billingForm.values.shippingCity || billingForm.values.city,
          weight: productWeight,
        };

        setCostLoading(true);
        try {
          const response = await Shipstation.instance.getShipRates(payload);
          if (Array.isArray(response.data)) {
            setShippingCostOption(response.data);
          } else {
            handleSnackbar(true, "The address you entered is invalid", "error");
            setShippingCostOption([]);
          }
        } catch (error) {
          console.error("Error fetching shipping rates:", error);
          setShippingCostOption([]);
        } finally {
          setCostLoading(false);
        }
      };

      fetchShipRates();
    } else {
      setShippingCostOption([]);
      billingForm.setFieldValue("shippingCostOption", "");
    }
  }, [
    billingForm.values.shippingEnvelope,
    billingForm.values.shippingOptions,
    billingForm.values.shippingState,
    billingForm.values.shippingZip,
    billingForm.values.shippingCity,
    billingForm.values.state,
    billingForm.values.zip,
  ]);

  const handleCostCalculation = (selectedServiceCode: string) => {
    const selectedOption = shippingCostOption?.find(
      (option) => option.serviceCode === selectedServiceCode
    );
    if (selectedOption) {
      const totalCost = selectedOption.shipmentCost + selectedOption.otherCost;
      setShippingCost(totalCost);
    }
  };

  console.log(
    "billingSameAsShipping--",
    billingForm.values.billingSameAsShipping
  );

  return (
    <Box component="form" sx={{ mt: 2 }} className="invoice-information">
      <Box
        sx={{
          display: "flex",
          gap: 1,
          justifyContent: "center",
          margin: "8px 0px",
        }}
      >
        <Box
          sx={{
            flex: 1,
            "& .MuiOutlinedInput-input": {
              color: "#333333",
              fontWeight: 600,
            },
          }}
        >
          <CustomInput
            value={billingForm.values.invoiceNo}
            onChangeText={(value) =>
              billingForm.setFieldValue("invoiceNo", value)
            }
            errorMessage={billingForm.errors.invoiceNo as string}
            isError={
              (isValidString(billingForm.errors.invoiceNo) &&
                billingForm.touched.invoiceNo) ||
              false
            }
            readOnly
            disabled={true}
            handleBlur={billingForm.handleBlur("invoiceNo")}
            required={false}
            label="Invoice #"
            placeholder="PTP000234"
            size="small"
            containerStyle={{ marginTop: "-1px", mb: "2px" }}
          />
        </Box>

        <Box sx={{ flex: 1 }}>
          <InputLabel
            sx={{ fontSize: 12, color: Colors.textColor, fontWeight: 700 }}
          >
            Status
          </InputLabel>
          <Select
            labelId="demo-select-small-label"
            id="demo-select-small"
            value={billingForm.values.invoiceStatus}
            inputProps={{ "aria-label": "Without label" }}
            onChange={(e) =>
              billingForm.setFieldValue("invoiceStatus", e.target.value)
            }
            fullWidth
            size="small"
            sx={{ mt: 0.5, pb: 0.2, height: "32px" }}
          >
            {orderStatuses.map((status) => (
              <MenuItem key={status} value={status}>
                {status}
              </MenuItem>
            ))}
          </Select>
        </Box>

        <Box sx={{ flex: 1 }}>
          <DatePicker
            customInput={
              <CustomInput
                value={billingForm.values.date || ""}
                onChangeText={(value) => {
                  const parsedDate = new Date(value);
                  if (!isNaN(parsedDate.getTime())) {
                    billingForm.setFieldValue("date", parsedDate);
                  }
                }}
                errorMessage=""
                isError={false}
                editable={false}
                handleBlur={billingForm.handleBlur("date")}
                required={false}
                label="Date"
                placeholder="Nov 3,2023"
                size="small"
                containerStyle={{ marginTop: "-1px" }}
                handleOnClick={() => setShowDateCalendar(true)}
              />
            }
            open={showDateCalendar}
            onClickOutside={() => setShowDateCalendar(false)}
            selected={billingForm.values.date}
            onChange={(date) => {
              billingForm.setFieldValue("date", date);
              setShowDateCalendar(false);
            }}
          />
        </Box>

        <Box sx={{ flex: 1 }}>
          <DatePicker
            customInput={
              <CustomInput
                value={billingForm.values.dueDate || ""}
                onChangeText={(value) => {
                  const parsedDate = new Date(value);
                  if (!isNaN(parsedDate.getTime())) {
                    billingForm.setFieldValue("dueDate", parsedDate);
                  }
                }}
                errorMessage=""
                isError={false}
                editable={false}
                handleBlur={billingForm.handleBlur("dueDate")}
                required={false}
                label="Due Date"
                placeholder="Nov 3,2023"
                size="small"
                containerStyle={{ marginTop: "-1px" }}
                handleOnClick={() => setShowCalendar(true)}
              />
            }
            open={showCalendar}
            onClickOutside={() => setShowCalendar(false)}
            selected={billingForm.values.dueDate}
            onChange={(dueDate) => {
              billingForm.setFieldValue("dueDate", dueDate);
              setShowCalendar(false);
            }}
          />
        </Box>

        <Box sx={{ flex: 1 }}>
          <InputLabel
            sx={{ fontSize: 12, color: Colors.textColor, fontWeight: 700 }}
          >
            Customer Type
          </InputLabel>
          <Select
            labelId="demo-select-small-label"
            id="demo-select-small"
            inputProps={{ "aria-label": "Without label" }}
            value={billingForm.values.customerType}
            onChange={(e) => {
              billingForm.setFieldValue("customerType", e.target.value);
              setProduct([initialStateProduct]);
            }}
            fullWidth
            size="small"
            placeholder="Customer Type"
            sx={{ mt: 0.5, pb: 0.2, height: "32px" }}
          >
            <MenuItem value={"Retail"}>Retail</MenuItem>
            <MenuItem value={"Wholesale"}>Wholesale</MenuItem>
            <MenuItem value={"In_House"}>In House</MenuItem>
          </Select>
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mt: -1,
          mb: 2,
        }}
      >
        <CustomInput
          value={billingForm.values.poNumber}
          onChangeText={(value) => {
            billingForm.setFieldValue("poNumber", value);
          }}
          errorMessage={billingForm.errors.poNumber as string}
          isError={
            (isValidString(billingForm.errors.poNumber) &&
              billingForm.touched.poNumber) ||
            false
          }
          handleBlur={billingForm.handleBlur("poNumber")}
          required={false}
          label="P.O Number*"
          placeholder="P.O Number"
          size="small"
          containerStyle={{ flex: 0.8, marginTop: 1 }}
          labelStyle={{ fontWeight: 400, color: "#666666" }}
          maxLength={32}
        />

        <CustomInput
          value={billingForm.values.salesRep || ""}
          onChangeText={(value) => {
            billingForm.setFieldValue("salesRep", value);
          }}
          errorMessage={billingForm.errors.salesRep as string}
          isError={
            (isValidString(billingForm.errors.salesRep) &&
              billingForm.touched.salesRep) ||
            false
          }
          handleBlur={billingForm.handleBlur("salesRep")}
          required={false}
          label="Sales Rep*"
          placeholder="Sales Rep"
          size="small"
          containerStyle={{ flex: 0.8, marginLeft: "8px", marginTop: 1 }}
          labelStyle={{ fontWeight: 400, color: "#666666" }}
          maxLength={32}
          disabled={true}
        />
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mt: 1,
          mb: -1,
        }}
      >
        <Typography variant="body1" component={"h6"} className="title-01">
          {Strings.billingInformation}
        </Typography>

        {showAddCustomerBtn && (
          <CustomEllipticalButton
            buttonSize="xs"
            buttonHeight="sm"
            label="Add new Customer"
            onBtnClick={() => navigate("/customers/createCustomer")}
            uppercase={false}
            variant="contained"
            buttonColor={Colors.secondary}
            labelColor={Colors.white}
          />
        )}
      </Box>

      <Box>
        <Box>
          <CustomInput
            value={billingForm.values.display_name}
            onChangeText={(value) => {
              billingForm.setFieldValue("display_name", value);
              setCustomerQuery(value);
              debouncedSearchCustomer(value);
            }}
            errorMessage={billingForm.errors.display_name as string}
            isError={
              (isValidString(billingForm.errors.display_name) &&
                billingForm.touched.display_name) ||
              false
            }
            handleBlur={billingForm.handleBlur("display_name")}
            required={false}
            label="Customer Name*"
            placeholder="John Doe"
            size="small"
            inputClassName="label-text01"
          />

          <Box sx={{ position: "relative", marginTop: 1 }}>
            {customerLoading ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress size={24} />
              </Box>
            ) : (
              customerQuery &&
              customerDropDown && (
                <Box
                  sx={{
                    position: "absolute",
                    top: "100%",
                    left: 0,
                    right: 0,
                    bgcolor: "#fff",
                    borderRadius: "0 0 25px 25px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                    zIndex: 10,
                    maxHeight: "200px",
                    overflowY: "scroll",
                  }}
                >
                  <List>
                    {customerSearchResult.length > 0 ? (
                      customerSearchResult.map((result) => (
                        <ListItem
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                          button
                          key={result.qb_customer_id}
                          onClick={() => handleCustomerClick(result)}
                        >
                          <Typography>{result.display_name}</Typography>
                        </ListItem>
                      ))
                    ) : (
                      <ListItem>
                        <Typography>No results found</Typography>
                      </ListItem>
                    )}
                  </List>
                </Box>
              )
            )}
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "-4px",
          }}
        >
          <CustomInput
            value={billingForm.values.email}
            onChangeText={(value) => {
              billingForm.setFieldValue("email", value);
            }}
            errorMessage={billingForm.errors.email as string}
            isError={
              (isValidString(billingForm.errors.email) &&
                billingForm.touched.email) ||
              false
            }
            handleBlur={billingForm.handleBlur("email")}
            required={false}
            label="Email*"
            placeholder="example@example.com"
            size="small"
            containerStyle={{ flex: 0.8, marginTop: 1 }}
            labelStyle={{ fontWeight: 400, color: "#666666" }}
          />

          <CustomInput
            value={billingForm.values.phoneNo?.toString() || ""}
            onChangeText={(value) => {
              billingForm.setFieldValue("phoneNo", value);
            }}
            errorMessage={billingForm.errors.phoneNo as string}
            isError={
              (isValidString(billingForm.errors.phoneNo) &&
                billingForm.touched.phoneNo) ||
              false
            }
            handleBlur={billingForm.handleBlur("phoneNo")}
            required={false}
            label="Phone*"
            placeholder="(774)-222-2390"
            size="small"
            containerStyle={{ flex: 0.8, marginLeft: "8px", marginTop: 1 }}
            labelStyle={{ fontWeight: 400, color: "#666666" }}
            maxLength={13}
          />
        </Box>

        <Box sx={{ marginTop: "-12px" }}>
          <CustomInput
            value={billingForm.values.address}
            onChangeText={(value) => {
              billingForm.setFieldValue("address", value);
            }}
            errorMessage={billingForm.errors.address as string}
            isError={
              (isValidString(billingForm.errors.address) &&
                billingForm.touched.address) ||
              false
            }
            handleBlur={billingForm.handleBlur("address")}
            required={false}
            label="Address*"
            placeholder="123 Seasame st."
            size="small"
            labelStyle={{ fontWeight: 400, color: "#666666" }}
          />
        </Box>

        <Box
          sx={{
            display: "flex",
            gap: "5px",
            justifyContent: "space-between",
            marginTop: "-8px",
            alignItems: "center",
          }}
        >
          {/* <CustomInput
            value={billingForm.values.city}
            onChangeText={(value) => {
              billingForm.setFieldValue("city", value);
            }}
            errorMessage={billingForm.errors.city as string}
            isError={
              (isValidString(billingForm.errors.city) &&
                billingForm.touched.city) ||
              false
            }
            handleBlur={billingForm.handleBlur("city")}
            required={false}
            label="City*"
            placeholder="Shrewsbury"
            size="small"
            containerStyle={{ flex: 0.8 }}
            labelStyle={{ fontWeight: 400, color: "#666666" }}
          /> */}

          <Box sx={{ flex: 0.5, margin: "14px 4px 0px" }}>
            <InputLabel
              sx={{
                fontSize: 12,
                mb: "2px",
                color: Colors.textColor,
                fontWeight: 400,
              }}
            >
              State*
            </InputLabel>

            {/* <Select
              labelId="demo-select-small-label"
              id="demo-select-small"
              value={billingForm.values.state || ""}
              inputProps={{ "aria-label": "Without label" }}
              onChange={(e) => {
                billingForm.setFieldValue("state", e.target.value);
              }}
              fullWidth
              size="small"
              placeholder="MA"
              sx={{ mt: 0.5, pb: 0.2, height: "32px" }}
            >
              {stateOptions.map((state) => (
                <MenuItem key={state} value={state}>
                  {state}
                </MenuItem>
              ))}
            </Select> */}

            <Select
              labelId="demo-select-small-label"
              id="demo-select-small"
              value={billingForm.values.state || state}
              onChange={(e) => {
                const selectedState = e.target.value;
                setState(selectedState);
                billingForm.setFieldValue("state", selectedState);
                setCity("");
                billingForm.setFieldValue("city", "");
              }}
              fullWidth
              size="small"
              sx={{ mt: 0.5, pb: 0.2, height: "32px" }}
            >
              {stateOptions.map((stateOption) => (
                <MenuItem key={stateOption.isoCode} value={stateOption.isoCode}>
                  {stateOption.isoCode}
                </MenuItem>
              ))}
            </Select>
          </Box>

          <Box sx={{ flex: 0.5, margin: "14px 4px 0px" }}>
            <InputLabel
              sx={{
                fontSize: 12,
                mb: "2px",
                color: Colors.textColor,
                fontWeight: 400,
              }}
            >
              City*
            </InputLabel>

            <Select
              labelId="demo-select-small-label"
              id="demo-select-small"
              value={billingForm.values.city || city}
              onChange={(e) => {
                const selectedCity = e.target.value;
                setCity(selectedCity);
                billingForm.setFieldValue("city", selectedCity);
              }}
              fullWidth
              size="small"
              sx={{ mt: 0.5, pb: 0.2, height: "32px" }}
            >
              {cityOptions.map((cityOption) => (
                <MenuItem key={cityOption.name} value={cityOption.name}>
                  {cityOption.name}
                </MenuItem>
              ))}
            </Select>
          </Box>

          <CustomInput
            value={billingForm.values.zip}
            onChangeText={(value) => {
              billingForm.setFieldValue("zip", value);
            }}
            errorMessage={billingForm.errors.zip as string}
            isError={
              (isValidString(billingForm.errors.zip) &&
                billingForm.touched.zip) ||
              false
            }
            handleBlur={billingForm.handleBlur("zip")}
            required={false}
            label="Zipcode*"
            placeholder="01545"
            size="small"
            containerStyle={{ flex: 0.8 }}
            labelStyle={{ fontWeight: 400, color: "#666666" }}
          />
        </Box>

        {/* <Box sx={{ py: 2, display: "flex" }}>
          <Typography
            component={"h6"}
            className="invoice-title-01"
            sx={{ mr: 2 }}
          >
            {Strings.shippingInformation}{" "}
          </Typography>

          <FormGroup className="checkbox-label-text">
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  value={billingForm.values.billingSameAsShipping}
                />
              }
              label="Shipping Address is same as Billing Address"
              onChange={(e, checked) => {
              
                billingForm.setFieldValue("billingSameAsShipping", checked);
              }}
            />
          </FormGroup>
        </Box> */}

        <Box sx={{ py: 2, display: "flex" }}>
          <Typography
            component={"h6"}
            className="invoice-title-01"
            sx={{ mr: 2 }}
          >
            {Strings.shippingInformation}{" "}
          </Typography>

          <FormGroup className="checkbox-label-text">
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={billingForm.values.billingSameAsShipping}
                  onChange={(e, checked) => {
                    billingForm.setFieldValue("billingSameAsShipping", checked);
                  }}
                />
              }
              label="Shipping Address is same as Billing Address"
            />
          </FormGroup>
        </Box>
      </Box>

      {!billingForm.values.billingSameAsShipping && (
        <Box sx={{ marginTop: "-12px" }}>
          <CustomInput
            value={billingForm.values.shippingName}
            onChangeText={(value) => {
              billingForm.setFieldValue("shippingName", value);
            }}
            errorMessage={billingForm.errors.shippingName as string}
            isError={
              (isValidString(billingForm.errors.shippingName) &&
                billingForm.touched.shippingName) ||
              false
            }
            handleBlur={billingForm.handleBlur("shippingName")}
            required={false}
            label="Shipping Name*"
            placeholder="Shipping Name"
            size="small"
            labelStyle={{ fontWeight: 400, color: "#666666" }}
          />

          <CustomInput
            value={billingForm.values.shippingAddress}
            onChangeText={(value) => {
              billingForm.setFieldValue("shippingAddress", value);
            }}
            errorMessage={billingForm.errors.shippingAddress as string}
            isError={
              (isValidString(billingForm.errors.shippingAddress) &&
                billingForm.touched.shippingAddress) ||
              false
            }
            handleBlur={billingForm.handleBlur("shippingAddress")}
            required={false}
            label="Address*"
            placeholder="123 Seasame st."
            size="small"
            labelStyle={{ fontWeight: 400, color: "#666666" }}
          />

          <Box
            style={{
              display: "flex",
              gap: "5px",
              justifyContent: "space-between",
              marginTop: "-8px",
            }}
          >
            <Box sx={{ flex: 0.5, margin: "14px 4px 0px" }}>
              <InputLabel
                sx={{
                  fontSize: 12,
                  mb: "2px",
                  color: Colors.textColor,
                  fontWeight: 400,
                }}
              >
                State*
              </InputLabel>

              {/* <Select
                labelId="demo-select-small-label"
                id="demo-select-small"
                value={billingForm.values.shippingState}
                inputProps={{ "aria-label": "Without label" }}
                onChange={(e) => {
                  billingForm.setFieldValue("shippingState", e.target.value);
                }}
                fullWidth
                size="small"
                placeholder="MA"
                sx={{ mt: 0.5, pb: 0.2, height: "32px" }}
              >
                {shippingStateOptions.map((option) => (
                  <MenuItem key={state} value={state}>
                    {option}
                  </MenuItem>
                ))}
              </Select> */}

              <Select
                labelId="demo-select-small-label"
                id="demo-select-small"
                value={billingForm.values.shippingState || shippingState}
                onChange={(e) => {
                  const selectedShippingState = e.target.value;
                  setShippingState(selectedShippingState);
                  billingForm.setFieldValue(
                    "shippingState",
                    selectedShippingState
                  );
                  setShippingCity("");
                  billingForm.setFieldValue("shippingCity", "");
                }}
                fullWidth
                size="small"
                sx={{ mt: 0.5, pb: 0.2, height: "32px" }}
              >
                {shippingStateOptions.map((stateOption: any) => (
                  <MenuItem
                    key={stateOption.isoCode}
                    value={stateOption.isoCode}
                  >
                    {stateOption.isoCode}
                  </MenuItem>
                ))}
              </Select>
            </Box>

            <Box sx={{ flex: 0.5, margin: "14px 4px 0px" }}>
              <InputLabel
                sx={{
                  fontSize: 12,
                  mb: "2px",
                  color: Colors.textColor,
                  fontWeight: 400,
                }}
              >
                City*
              </InputLabel>

              <Select
                labelId="demo-select-small-label"
                id="demo-select-small"
                value={billingForm.values.shippingCity || shippingCity}
                onChange={(e) => {
                  const selectedShippingCity = e.target.value;
                  setShippingCity(selectedShippingCity);
                  billingForm.setFieldValue(
                    "shippingCity",
                    selectedShippingCity
                  );
                }}
                fullWidth
                size="small"
                sx={{ mt: 0.5, pb: 0.2, height: "32px" }}
              >
                {shippingCityOptions.map((cityOption) => (
                  <MenuItem key={cityOption.name} value={cityOption.name}>
                    {cityOption.name}
                  </MenuItem>
                ))}
              </Select>
            </Box>

            <CustomInput
              value={billingForm.values.shippingZip}
              onChangeText={(value) => {
                billingForm.setFieldValue("shippingZip", value);
              }}
              errorMessage={billingForm.errors.shippingZip as string}
              isError={
                (isValidString(billingForm.errors.shippingZip) &&
                  billingForm.touched.shippingZip) ||
                false
              }
              handleBlur={billingForm.handleBlur("shippingZip")}
              required={false}
              label="Zipcode*"
              placeholder="01545"
              size="small"
              containerStyle={{ flex: 0.8 }}
              labelStyle={{ fontWeight: 400, color: "#666666" }}
            />
          </Box>
        </Box>
      )}

      <Box sx={{ mt: 2 }}>
        <Typography variant="body1" component={"h6"} className="title-01">
          {Strings.products}
        </Typography>

        <Box sx={{ mt: 1 }}>
          {product.map((productItem, index) => (
            <React.Fragment key={productItem.id}>
              <Box
                style={{ display: "flex", justifyContent: "space-between" }}
                className="custom-product-row"
              >
                <Box
                  style={{
                    flex: 8,
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                  className="custom-product-row"
                >
                  <Box sx={{ flex: 8 }} className="custom-item-row">
                    <CustomInput
                      value={productItem.item}
                      onChangeText={(value) =>
                        handleInputChange(value, index, "item")
                      }
                      errorMessage=""
                      isError={false}
                      handleBlur={() => {}}
                      required={false}
                      label="Item"
                      placeholder="Product Name or Number"
                      size="small"
                      containerStyle={{ flex: 14 }}
                      labelStyle={{ fontWeight: 400, color: "#666666" }}
                    />
                  </Box>

                  <Box sx={{ mx: 1, flex: 2 }} className="custom-qty-number">
                    <InputLabel
                      sx={{ fontSize: 12, mb: "2px", fontWeight: 700 }}
                    >
                      Qty
                    </InputLabel>
                    <CustomInput
                      value={String(productItem.qty)}
                      onChangeText={(value) =>
                        handleInputChange(value, index, "qty")
                      }
                      errorMessage=""
                      isError={false}
                      handleBlur={() => {}}
                      required={false}
                      placeholder="Enter quantity"
                      size="small"
                      inputClassName="label-text01"
                    />
                  </Box>

                  <Box
                    sx={{
                      flex: 2,
                      "& .MuiOutlinedInput-input": {
                        color: "#333333",
                        fontWeight: 600,
                      },
                    }}
                    className="custom-price-row"
                  >
                    <CustomInput
                      value={`$${Number(productItem.price).toFixed(2)}`}
                      onChangeText={(value) =>
                        handleInputChange(value, index, "price")
                      }
                      errorMessage=""
                      isError={false}
                      handleBlur={() => {}}
                      required={false}
                      label="Price"
                      placeholder="$50.00"
                      size="small"
                      labelStyle={{ fontWeight: 400, color: "#666666" }}
                      disabled={true} // Remove if not needed
                    />
                  </Box>
                </Box>

                {product.length > 1 && (
                  <Box
                    sx={{ flex: 0.7, cursor: "pointer", mt: 4, ml: 1 }}
                    onClick={() => removeRow(productItem.id)}
                  >
                    <RemoveCircleIcon sx={{ color: "red" }} />
                  </Box>
                )}
              </Box>
            </React.Fragment>
          ))}

          <Box sx={{ position: "relative", marginTop: 1 }}>
            {loading ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress size={24} />
              </Box>
            ) : (
              searchQuery &&
              showDropDown && (
                <Box
                  sx={{
                    position: "absolute",
                    top: "100%",
                    left: 0,
                    right: 0,
                    bgcolor: "#fff",
                    borderRadius: "0 0 25px 25px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                    zIndex: 10,
                    maxHeight: "200px",
                    overflowY: "scroll",
                  }}
                >
                  <List>
                    {searchResults.length > 0 ? (
                      searchResults.map((result, index) => (
                        <ListItem
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                          button
                          key={
                            result.productId || result.productListingObjectId
                          }
                          onClick={() => handleResultClick(result)}
                        >
                          <Typography>{result?.name.trim()}</Typography>

                          <Typography>
                            {(() => {
                              let price;
                              switch (billingForm.values.customerType) {
                                case "Wholesale":
                                  price = result?.wholesalePrice;
                                  break;
                                case "In_House":
                                  price = result?.company_cost;
                                  break;
                                case "Retail":
                                default:
                                  price = result?.unitPrice;
                                  break;
                              }
                              return `$${Number(price).toFixed(2)}`;
                            })()}
                          </Typography>
                        </ListItem>
                      ))
                    ) : (
                      <ListItem>
                        <Typography>No results found</Typography>
                      </ListItem>
                    )}
                  </List>
                </Box>
              )
            )}
          </Box>

          <Box className="custom-add-product" sx={{ mt: 2 }}>
            <span onClick={addProductRow}>
              <AddCircleIcon /> <span>Add Product</span>
            </span>
          </Box>
        </Box>

        <Box sx={{ mt: 2 }}>
          <Box sx={{ display: "flex" }}>
            <Box sx={{ flex: 2 }}>
              <FormControl sx={{ width: 300 }} size="small">
                <InputLabel
                  sx={{
                    fontSize: 12,
                    mb: "2px",
                    color: Colors.textColor,
                    fontWeight: 400,
                  }}
                >
                  Shipping Options
                </InputLabel>

                <Select
                  labelId="shipping-options-select-label"
                  id="shipping-options-select"
                  value={billingForm.values.shippingOptions}
                  onChange={(e) =>
                    billingForm.setFieldValue("shippingOptions", e.target.value)
                  }
                  fullWidth
                  label="Shipping Options"
                >
                  {carrierloading ? (
                    <MenuItem disabled>Loading...</MenuItem>
                  ) : (
                    shippingOptions.map((option: any, index: number) => (
                      <MenuItem key={index} value={option.code}>
                        {option.name}
                      </MenuItem>
                    ))
                  )}
                </Select>
              </FormControl>

              {billingForm.values.shippingOptions && (
                <Box sx={{ my: 2 }}>
                  <FormControl sx={{ width: 300 }} size="small">
                    <InputLabel
                      sx={{
                        fontSize: 12,
                        mb: "2px",
                        color: Colors.textColor,
                        fontWeight: 400,
                      }}
                    >
                      Shipping Envelope
                    </InputLabel>

                    <Select
                      labelId="demo-select-small-label"
                      id="demo-select-small"
                      value={billingForm.values.shippingEnvelope}
                      onChange={(e) => {
                        billingForm.setFieldValue(
                          "shippingEnvelope",
                          e.target.value
                        );
                      }}
                      label="Shipping Envelope"
                    >
                      {envelopeLoading ? (
                        <MenuItem disabled>Loading...</MenuItem>
                      ) : (
                        shippingEnvelope.map((option: any, index: number) => (
                          <MenuItem key={index} value={option.code}>
                            {option.name}
                          </MenuItem>
                        ))
                      )}
                    </Select>
                  </FormControl>
                </Box>
              )}

              {billingForm.values.shippingEnvelope && (
                <Box>
                  <FormControl sx={{ width: 300 }} size="small">
                    <InputLabel
                      sx={{
                        fontSize: 12,
                        mb: "2px",
                        color: Colors.textColor,
                        fontWeight: 400,
                      }}
                    >
                      Shipping Cost
                    </InputLabel>

                    <Select
                      labelId="demo-select-small-label"
                      id="demo-select-small"
                      value={billingForm.values.shippingCostOption}
                      onChange={(e) => {
                        const selectedValue = e.target.value;
                        billingForm.setFieldValue(
                          "shippingCostOption",
                          selectedValue
                        );
                        handleCostCalculation(selectedValue);
                      }}
                      fullWidth
                      label="Shipping Envelope"
                    >
                      {costLoading ? (
                        <MenuItem disabled>Loading...</MenuItem>
                      ) : Array.isArray(shippingCostOption) ? (
                        shippingCostOption.length > 0 ? (
                          shippingCostOption.map((option, index) => {
                            const totalCost =
                              option.shipmentCost + option.otherCost;
                            return (
                              <MenuItem
                                key={index}
                                value={option.serviceCode}
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <span>{option.serviceName}</span>
                                <span>${totalCost.toFixed(2)}</span>
                              </MenuItem>
                            );
                          })
                        ) : (
                          <MenuItem disabled>
                            No shipping options available
                          </MenuItem>
                        )
                      ) : (
                        <MenuItem disabled>
                          Error: Shipping cost options are not available
                        </MenuItem>
                      )}
                    </Select>
                  </FormControl>
                </Box>
              )}

              <Grid container>
                <Box
                  sx={{ display: "flex", gap: 1, alignItems: "center", mt: 2 }}
                >
                  <Grid item sm={4} className="custom-discount-option">
                    <Select
                      labelId="demo-select-small-label"
                      id="demo-select-small"
                      inputProps={{ "aria-label": "Without label" }}
                      value={billingForm.values.salesTax}
                      onChange={(e) => {
                        billingForm.setFieldValue("salesTax", e.target.value);
                      }}
                      fullWidth
                      size="small"
                      placeholder="Sales Tax"
                    >
                      <MenuItem value={"6"}>Florida 6%</MenuItem>
                      <MenuItem value={"0"}>Tax Exempt 0%</MenuItem>
                    </Select>
                  </Grid>

                  <Grid item sm={4} sx={{ mt: -2 }}>
                    <CustomInput
                      value={billingForm.values.discounts}
                      onChangeText={(value) => {
                        billingForm.setFieldValue("discounts", value);
                      }}
                      errorMessage={billingForm.errors.discounts as string}
                      isError={
                        (isValidString(billingForm.errors.discounts) &&
                          billingForm.touched.discounts) ||
                        false
                      }
                      handleBlur={billingForm.handleBlur("discounts")}
                      required={false}
                      // label="Discounts"
                      placeholder="Discounts"
                      size="small"
                      type="number"
                      labelStyle={{ fontWeight: 400, color: "#666666" }}
                    />
                  </Grid>

                  <Grid item sm={4} className="custom-discount-option">
                    <Select
                      labelId="demo-select-small-label"
                      id="demo-select-small"
                      inputProps={{ "aria-label": "Without label" }}
                      value={billingForm.values.option}
                      onChange={(e) => {
                        billingForm.setFieldValue("option", e.target.value);
                      }}
                      fullWidth
                      size="small"
                      placeholder="Option"
                    >
                      <MenuItem value={"Amount"}>Amount</MenuItem>
                      <MenuItem value={"Percent"}>Percent</MenuItem>
                    </Select>
                  </Grid>
                </Box>

                <Grid sm={12} sx={{ mt: 2 }}>
                  <InputLabel
                    sx={{
                      fontSize: 12,
                      mb: "2px",
                      color: Colors.textColor,
                      fontWeight: 400,
                    }}
                  >
                    Notes
                  </InputLabel>
                  <TextareaAutosize
                    aria-label="minimum height"
                    minRows={3}
                    placeholder="Type Notes"
                    style={{
                      width: "100%",
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                    }}
                    value={billingForm.values.notes}
                    onChange={(e) => {
                      billingForm.setFieldValue("notes", e.target.value);
                    }}
                    onBlur={billingForm.handleBlur("notes")}
                  />
                </Grid>
              </Grid>
            </Box>

            <Box
              sx={{
                flex: 1,
                justifyContent: "flex-end",
                mx: 5,
                mt: 5,
                textAlign: "right",
              }}
            >
              <Table className="custom-table-content">
                <TableBody>
                  <TableRow>
                    <TableCell>Sub Total:</TableCell>
                    <TableCell align="right">
                      ${getSubtotal().toFixed(2)}
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell>Discounts: </TableCell>
                    <TableCell align="right">
                      (
                      {billingForm.values.discounts
                        ? `$${billingForm.values.discounts}`
                        : "$0"}
                      )
                    </TableCell>
                  </TableRow>
                  <br />

                  {billingForm.values.discounts && (
                    <TableRow>
                      <TableCell>Sub Total (After Discount):</TableCell>
                      <TableCell align="right">${getTotal()}</TableCell>
                    </TableRow>
                  )}

                  <TableRow>
                    <TableCell>Shipping: </TableCell>
                    <TableCell align="right">
                      ${shippingCost.toFixed(2)}
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell>Tax:</TableCell>
                    <TableCell align="right">
                      {`${billingForm.values.salesTax}%`}
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell sx={{ fontSize: 15 }}>Order Total:</TableCell>
                    <TableCell colSpan={2} align="right" sx={{ fontSize: 15 }}>
                      ${getGrandTotal()}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Box>
          </Box>
          <Box sx={{ mt: 2 }}>
            <Grid container>
              <Grid sm={3}>
                <CustomEllipticalButton
                  buttonSize="xs"
                  buttonHeight="sm"
                  label="Save Draft"
                  onBtnClick={handleSavedDraft}
                  uppercase={false}
                  variant="contained"
                  buttonColor={Colors.secondary}
                  labelColor={Colors.white}
                  startIcon={<SaveOutlinedIcon />}
                />
              </Grid>
              <Grid sm={5}></Grid>

              <Grid sm={2}>
                <CustomEllipticalButton
                  buttonSize="xs"
                  buttonHeight="sm"
                  label="Clear"
                  onBtnClick={() => {
                    resetFormDetails();
                  }}
                  uppercase={false}
                  variant="contained"
                  buttonColor={Colors.secondary}
                  labelColor={Colors.white}
                  buttonContainerStyle={{
                    backgroundColor: Colors.white,
                    color: Colors.secondary,
                    borderColor: "red",
                  }}
                />
              </Grid>

              <Grid sm={2}>
                <CustomEllipticalButton
                  buttonSize="xs"
                  buttonHeight="sm"
                  label="Send"
                  onBtnClick={() => {
                    billingForm.handleSubmit();
                  }}
                  disabled={billingForm.isSubmitting}
                  uppercase={false}
                  variant="contained"
                  buttonColor={Colors.secondary}
                  labelColor={Colors.white}
                />
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default InvoiceInformation;
